import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useTokenContext } from '@app/feature/token/token.context';

export const TokenDeleteFormStep1Controller = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const token = useTokenContext();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <>
      <Text bold>
        {t('$.token-delete.step-1.confirm', {
          name: token.authId,
        })}
      </Text>
      <Text italic>{t('$.token-delete.step-1.warning')}</Text>
    </>
  );
};
